import { render, staticRenderFns } from "./quickCourseList.vue?vue&type=template&id=0eb2c676"
import script from "./quickCourseList.vue?vue&type=script&lang=js"
export * from "./quickCourseList.vue?vue&type=script&lang=js"
import style0 from "./quickCourseList.vue?vue&type=style&index=0&id=0eb2c676&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports